import React, { lazy, Suspense } from 'react';
import { Router } from './Router/index.web';
import { ROUTES } from './types/global/routes.types';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from './module/ProtectedRoute';
import * as Sentry from '@sentry/react';
import { APILoader } from './pages';
import { MainLoading as Loading } from './components/Loading/MainLoading';
import { EsMyProfileContainerLoadingState } from './components/ScreenContainer/EsMyProfileContainer/EsMyProfileContainerLoadingState';
import { DiscoveryShimmer } from './pages/DiscoveryShimmer';
import { ViewContestShimmer } from './pages/ViewContestShimmer';
import { TrendingVideosShimmer } from './pages/TrendingVideosShimmer';
import { ComingSoonShimmer } from './pages/ComingSoonShimmer';
import { ActiveContestShimmer } from './pages/ActiveContestShimmer';
import { WatchShimmer } from './pages/WatchShimmer';
import { UserProjectsShimmer } from './pages/UserProjectsShimmer';
import { FooterPageShimmer } from './pages/FooterPageShimmer';
import { JuryPageShimmer } from './pages/JuryPageShimmer';
import { SearchContainerShimmer } from './pages/SearchContainerShimmer';
import { E_USER_PERMISSIONS } from './types/global/user.models';
import { Spinner } from './components/Loading/Spinner';

const BuzzBridgeDashboardRedirect = lazy(() =>
    //@ts-ignore
    import('./pages/MenuDashboard/BuzzBridgeDashboardRedirect').then(module => {
        return { default: module.BuzzBridgeDashboardRedirect };
    }),
);

const CreatorCampaignWorkspacePage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.CreatorCampaignWorkspacePage };
    }),
);

const CreatorSubmitWorkPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.CreatorSubmitWorkPage };
    }),
);

const WorkShop = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.WorkShop };
    }),
);

const ProjectDetails = lazy(() =>
    //@ts-ignore
    import('./pages/ProjectDetails').then(module => {
        return { default: module.ProjectDetails };
    }),
);

const WorkProfile = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.WorkProfile };
    }),
);

const Company = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Company };
    }),
);

const BuzzBridgeDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BuzzBridgeDetails };
    }),
);

const BuzzBridge = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BuzzBridgeLandingPage };
    }),
);

const ReferralRedirectPage = lazy(() =>
    //@ts-ignore
    import('./pages/ReferralRedirect').then(module => ({
        default: module.ReferralRedirectPage,
    })),
);

const BuzzBridgeRewardsDashboardPage = lazy(() =>
    //@ts-ignore
    import('./pages/BuzzBridge/Loyalty/BuzzBridgeRewardsDashboardPage').then(m => ({
        default: m.BuzzBridgeRewardsDashboardPage,
    })),
);

const BuzzBridgeRewardsNetworkPage = lazy(() =>
    //@ts-ignore
    import('./pages/BuzzBridge/Loyalty/BuzzBridgeRewardsNetworkPage').then(m => ({
        default: m.BuzzBridgeRewardsNetworkPage,
    })),
);

const BuzzBridgeRewardsMemberPage = lazy(() =>
    //@ts-ignore
    import('./pages/BuzzBridge/Loyalty/BuzzBridgeRewardsMemberPage').then(m => ({
        default: m.BuzzBridgeRewardsMemberPage,
    })),
);

const BuzzBridgeRewardsRedeemPage = lazy(() =>
    //@ts-ignore
    import('./pages/BuzzBridge/Loyalty/BuzzBridgeRewardsRedeemPage').then(m => ({
        default: m.BuzzBridgeRewardsRedeemPage,
    })),
);

const AdminBuzzbridgeLoyaltyPage = lazy(() =>
    //@ts-ignore
    import('./pages/AdminBuzzbridgeLoyalty/AdminBuzzbridgeLoyaltyPage').then(m => ({
        default: m.AdminBuzzbridgeLoyaltyPage,
    })),
);

const OAuthCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.OAuthCallbackPage };
    }),
);

const Messages = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Messages };
    }),
);
const ConversationView = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ConversationView };
    }),
);

const ManageAudition = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageAudition };
    }),
);

const Events = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Events };
    }),
);

const EventDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.EventDetails };
    }),
);

const Audition = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Audition };
    }),
);

const AuditionDetails = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AuditionDetails };
    }),
);

const AccountSettings = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountSettings };
    }),
);

const AccountBilling = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountBilling };
    }),
);
const AccountCommunications = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountCommunications };
    }),
);
const AccountNotifications = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountNotifications };
    }),
);
const AccountPreference = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountPreference };
    }),
);

const AccountPreferences = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountPreference };
    }),
);

const AccountSubscription = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountSubscriptions };
    }),
);
const AccountExternalBankAccounts = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AccountExternalBankAccounts };
    }),
);

// const HomePage = en_config.WIP ? Splash : Home;
const EsDiscovery = lazy(() =>
    //@ts-ignore
    import('./pages/EsDiscovery/EsDiscovery').then(module => {
        return { default: module.EsDiscovery };
    }),
);

const SandboxExplorePage = lazy(() =>
    //@ts-ignore
    import('./pages/Sandbox').then(module => {
        return { default: module.SandboxExplorePage };
    }),
);

const SandboxCoursePage = lazy(() =>
    //@ts-ignore
    import('./pages/Sandbox').then(module => {
        return { default: module.SandboxCoursePage };
    }),
);

const SandboxPlayerPage = lazy(() =>
    //@ts-ignore
    import('./pages/Sandbox').then(module => {
        return { default: module.SandboxPlayerPage };
    }),
);

const SandboxStudioPage = lazy(() =>
    //@ts-ignore
    import('./pages/Sandbox').then(module => {
        return { default: module.SandboxStudioPage };
    }),
);

const AppLayout = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.AppLayout };
    }),
);

const EsLogin = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.EsLogin };
    }),
);

const Signup = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Signup };
    }),
);
const ModernPageNotFound = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ModernPageNotFound };
    }),
);
const PrivacyPolicy = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.PrivacyPolicy };
    }),
);
const DeleteAccount = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.DeleteAccount };
    }),
);
const HelpCenter = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.HelpCenter };
    }),
);
const FAQ = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.FAQ };
    }),
);
const Advertise = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Advertise };
    }),
);
const Search = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Search };
    }),
);
const Shop = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Shop };
    }),
);
const TermsOfUse = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.TermsOfUse };
    }),
);
const ErrorBoundary = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ErrorBoundary };
    }),
);

const EsSettings = lazy(() =>
    //@ts-ignore
    import('./pages/EsSettings').then(module => {
        return { default: module.EsSettings };
    }),
);

const BrandDashboardLayout = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandDashboardLayout };
    }),
);
const BrandDashboardHome = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandDashboardHome };
    }),
);
const BrandCampaignsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignsPage };
    }),
);
const BrandNewCampaignPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandNewCampaignPage };
    }),
);
const BrandCampaignDetailPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignDetailPage };
    }),
);
const BrandContestManagePage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandContestManagePage };
    }),
);
const BrandCampaignParticipantPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignParticipantPage };
    }),
);
const BrandCampaignApplicationsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignApplicationsPage };
    }),
);
const BrandCampaignAcceptedCreatorsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignAcceptedCreatorsPage };
    }),
);
const BrandCampaignReportPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignReportPage };
    }),
);
const BrandAuditionDetailPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandAuditionDetailPage };
    }),
);
const BrandAuditionParticipantPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandAuditionParticipantPage };
    }),
);
const BrandFindTalentPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandFindTalentPage };
    }),
);
const BrandWalletPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandWalletPage };
    }),
);
const BrandWalletFundCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandWalletFundCallbackPage };
    }),
);
const BrandCampaignHostSubscriptionCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandCampaignHostSubscriptionCallbackPage };
    }),
);
const ContestTokenPaystackCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ContestTokenPaystackCallbackPage };
    }),
);
const BrandProfilePage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandProfilePage };
    }),
);
const BrandSubscriptionSettingsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandSubscriptionSettingsPage };
    }),
);
const BrandAdHubOAuthCallbackPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandAdHubOAuthCallbackPage };
    }),
);
const BrandManageHome = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageHome };
    }),
);
const BrandManageTeamPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageTeamPage };
    }),
);
const BrandManageContractsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageContractsPage };
    }),
);
const BrandManageContractCreatePage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageContractCreatePage };
    }),
);
const BrandManageContractSignPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageContractSignPage };
    }),
);
const BrandManageContractDetailPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageContractDetailPage };
    }),
);
const BrandManageCalendarPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageCalendarPage };
    }),
);
const BrandManageSocialPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageSocialPage };
    }),
);
const BrandManageAiPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageAiPage };
    }),
);
const BrandManageInboxPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageInboxPage };
    }),
);
const BrandManageSettingsPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageSettingsPage };
    }),
);
const BrandManageMyContractPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageMyContractPage };
    }),
);
const BrandManageUgcPage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.BrandManageUgcPage };
    }),
);
const PublicCreatorProfilePage = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.PublicCreatorProfilePage };
    }),
);

const ContractReviewPage = lazy(() =>
    //@ts-ignore
    import('./pages/ContractReview/ContractReviewPage').then(module => {
        return { default: module.default };
    }),
);

const EsMyProfile = lazy(() =>
    //@ts-ignore
    import('./pages/EsMyProfile').then(module => {
        return { default: module.EsMyProfile };
    }),
);

const ManageCampaign = lazy(() =>
    //@ts-ignore
    import('./pages/ManageCampaign').then(module => {
        return { default: module.ManageCampaign };
    }),
);

const EsViewContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsViewContest').then(module => {
        return { default: module.EsViewContest };
    }),
);

const Event = lazy(() =>
    //@ts-ignore
    import('./pages/EsViewContest').then(module => {
        return { default: module.Event };
    }),
);

const EsComingSoon = lazy(() =>
    //@ts-ignore
    import('./pages/EsComingSoon').then(module => {
        return { default: module.EsComingSoon };
    }),
);

const Dashboard = lazy(() =>
    //@ts-ignore
    import('./pages/MenuDashboard').then(module => {
        return { default: module.Dashboard };
    }),
);

const Talents = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.Talents };
    }),
);

const FindTalents = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.FindTalents };
    }),
);

const UserProjects = lazy(() =>
    //@ts-ignore
    import('./pages/UserProjects').then(module => {
        return { default: module.UserProjects };
    }),
);

const EsJoinContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsJoinContest').then(module => {
        return { default: module.EsJoinContest };
    }),
);

const EsLiveContests = lazy(() =>
    //@ts-ignore
    import('./pages/EsLiveContests').then(module => {
        return { default: module.EsLiveContests };
    }),
);

const EsAllContests = lazy(() =>
    //@ts-ignore
    import('./pages/EsAllContests').then(module => {
        return { default: module.EsAllContests };
    }),
);

const EsJuryDuty = lazy(() =>
    //@ts-ignore
    import('./pages/EsJuryDuty').then(module => {
        return { default: module.EsJuryDuty };
    }),
);

const EsJuryDutyReview = lazy(() =>
    //@ts-ignore
    import('./pages/EsJuryDuty').then(module => {
        return { default: module.EsJuryDutyReview };
    }),
);

const EsActiveContest = lazy(() =>
    //@ts-ignore
    import('./pages/EsActiveContest').then(module => {
        return { default: module.EsActiveContest };
    }),
);

const EsTrendingVideos = lazy(() =>
    //@ts-ignore
    import('./pages/EsTrendingVideos').then(module => {
        return { default: module.EsTrendingVideos };
    }),
);

// const EsWatchVideo = lazy(() =>
//     //@ts-ignore
//     import('./pages/EsWatchVideo').then(module => {
//         return { default: module.EsWatchVideo };
//     }),
// );

const WatchRouteHandler = lazy(() =>
    //@ts-ignore
    import('./pages/EsWatchVideo').then(module => {
        return { default: module.WatchRouteHandler };
    }),
);

const EsNewPassword = lazy(() =>
    //@ts-ignore
    import('./pages/EsNewPassword/EsNewPassword').then(module => {
        return { default: module.EsNewPassword };
    }),
);

const EsResetPassword = lazy(() =>
    //@ts-ignore
    import('./pages/EsResetPassword').then(module => {
        return { default: module.EsResetPassword };
    }),
);

const VerifyEmail = lazy(() =>
    //@ts-ignore
    import('./pages/VerifyEmail').then(module => {
        return { default: module.VerifyEmail };
    }),
);

const JuryAcceptance = lazy(() =>
    //@ts-ignore
    import('./pages/JuryAcceptance').then(module => {
        return { default: module.JuryAcceptance };
    }),
);

const Links = lazy(() =>
    //@ts-ignore
    import('./pages/Links').then(module => {
        return { default: module.Links };
    }),
);

// const Feed = lazy(() =>
//     //@ts-ignore
//     import('./pages').then(module => {
//         return { default: module.Feed };
//     }),
// );

const ContestSubmissions = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ContestSubmissions };
    }),
);

const ManageEvent = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageEvent };
    }),
);

const ManageContest = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageContest };
    }),
);
const ManageSubmission = lazy(() =>
    //@ts-ignore
    import('./pages').then(module => {
        return { default: module.ManageSubmission };
    }),
);

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(Router);

export const router = sentryCreateBrowserRouter(
    [
        {
            path: ROUTES.HOME,
            element: (
                <Suspense fallback={<Loading />}>
                    <AppLayout />
                </Suspense>
            ),
            errorElement: <ModernPageNotFound />,
            children: [
                { index: true, element: <Navigate to={ROUTES.API_LOADER} replace /> },
                {
                    path: ROUTES.API_LOADER,
                    element: <APILoader />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.AUDITION,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <Audition />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.MANAGE_AUDITION,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ManageAudition />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.PUBLIC_CREATOR_PROFILE,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <PublicCreatorProfilePage />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.WORK_PROFILE,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <WorkProfile />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.COMPANY,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <Company />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.GIG,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <Audition />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.AUDITION_DETAIL,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <AuditionDetails />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.GIG_DETAIL,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <AuditionDetails />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.EVENTS,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <Events />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },

                {
                    path: ROUTES.EVENT_DETAILS,
                    element: (
                        <Suspense fallback={<ViewContestShimmer />}>
                            <EventDetails />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                    action: () => {},
                    loader: async () => {
                        return true;
                    },
                    caseSensitive: true,
                    hasErrorBoundary: true,
                },
                {
                    path: ROUTES.ESDISCOVERY,
                    element: (
                        <Suspense fallback={<DiscoveryShimmer />}>
                            <EsDiscovery />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.SANDBOX,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <SandboxExplorePage />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.SANDBOX_STUDIO,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute accessCheck accessType={['tutor', 'admin', 'super-admin']}>
                                <SandboxStudioPage />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.SANDBOX_COURSE,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <SandboxCoursePage />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.SANDBOX_PLAYER,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute>
                                <SandboxPlayerPage />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESWATCH_VIDEO,
                    element: (
                        <Suspense fallback={<WatchShimmer />}>
                            <WatchRouteHandler />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.WATCH,
                    element: (
                        <Suspense fallback={<WatchShimmer />}>
                            <WatchRouteHandler />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESTRENDING,
                    element: (
                        <Suspense fallback={<TrendingVideosShimmer />}>
                            <EsTrendingVideos />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESCONTEST,
                    element: (
                        <Suspense fallback={<ActiveContestShimmer />}>
                            <ProtectedRoute>
                                <EsActiveContest />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESALL_CONTESTS,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <EsAllContests />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESJOIN_CONTESTS,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute>
                                <EsJoinContest />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESLIVE_CONTESTS,
                    element: <EsLiveContests />,
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESJURY_DUTY,
                    element: (
                        <ProtectedRoute
                            accessCheck
                            accessType={[
                                E_USER_PERMISSIONS.SUPER_ADMIN,
                                E_USER_PERMISSIONS.ADMIN,
                                E_USER_PERMISSIONS.JURY,
                            ]}>
                            <Suspense fallback={<JuryPageShimmer />}>
                                <EsJuryDuty />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESJURY_DUTY_REVIEW,
                    element: (
                        <ProtectedRoute
                            accessCheck
                            accessType={[
                                E_USER_PERMISSIONS.SUPER_ADMIN,
                                E_USER_PERMISSIONS.ADMIN,
                                E_USER_PERMISSIONS.JURY,
                            ]}>
                            <Suspense fallback={<JuryPageShimmer />}>
                                <EsJuryDutyReview />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeDashboardRedirect />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_CAMPAIGN_SUBMIT,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <CreatorSubmitWorkPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_CAMPAIGN_WORKSPACE,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <CreatorCampaignWorkspacePage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_DETAILS,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeDetails />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_REWARDS,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeRewardsDashboardPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_REWARDS_NETWORK,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeRewardsNetworkPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_REWARDS_MEMBER,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeRewardsMemberPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.BUZZ_BRIDGE_REWARDS_REDEEM,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <BuzzBridgeRewardsRedeemPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.UGC_CAMPAIGN_DETAIL,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BuzzBridgeDetails />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.TALENTS,
                    element: (
                        <ProtectedRoute
                            accessCheck
                            accessType={[
                                E_USER_PERMISSIONS.SUPER_ADMIN,
                                E_USER_PERMISSIONS.ADMIN,
                                E_USER_PERMISSIONS.CASTING_DIRECTOR,
                            ]}>
                            <Suspense fallback={<Loading />}>
                                <Talents />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.DISCOVER,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <FindTalents />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESCOMING_SOON,
                    element: (
                        <Suspense fallback={<ComingSoonShimmer />}>
                            <EsComingSoon />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.DASHBOARD,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Loading />}>
                                <Dashboard />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.DASHBOARD_LOYALTY_ADMIN,
                    element: (
                        <ProtectedRoute accessCheck accessType="admin">
                            <Suspense fallback={<Loading />}>
                                <AdminBuzzbridgeLoyaltyPage />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.CONTEST_SUBMISSIONS,
                    element: (
                        <Suspense fallback={<ViewContestShimmer />}>
                            <ContestSubmissions />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                    caseSensitive: true,
                    hasErrorBoundary: true,
                },
                {
                    path: ROUTES.ESVIEW_CONTEST,
                    element: (
                        <Suspense fallback={<ViewContestShimmer />}>
                            <EsViewContest />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                    action: () => {},
                    loader: async () => {
                        return true;
                    },
                    caseSensitive: true,
                    hasErrorBoundary: true,
                },
                {
                    path: ROUTES.ESCONTEST_ENGAGE,
                    element: (
                        <ProtectedRoute accessCheck accessType="admin">
                            <Suspense fallback={<ViewContestShimmer />}>
                                <ManageCampaign />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESMY_VIDEOS,
                    element: (
                        <ProtectedRoute showAuthModal>
                            <Suspense fallback={<UserProjectsShimmer />}>
                                <UserProjects />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.REFERRAL_LINK,
                    element: (
                        <Suspense fallback={<Spinner />}>
                            <ReferralRedirectPage />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESMY_PROFILE,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<EsMyProfileContainerLoadingState />}>
                                <EsMyProfile />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.USER,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<EsMyProfileContainerLoadingState />}>
                                <EsMyProfile />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.SEARCH,
                    element: (
                        <Suspense fallback={<SearchContainerShimmer />}>
                            <Search />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.ESSETTINGS,
                    element: <Navigate to={ROUTES.ACCOUNT_SETTINGS} replace />,
                },
                {
                    path: ROUTES.EVENT_CUSTOM,
                    element: (
                        <Suspense fallback={<ViewContestShimmer />}>
                            <Event />
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                    action: () => {},
                    loader: async () => {
                        return true;
                    },
                    caseSensitive: true,
                    hasErrorBoundary: true,
                },
                {
                    path: ROUTES.ACCOUNT,
                    element: (
                        <Suspense fallback={<Spinner />}>
                            <ProtectedRoute>
                                <AccountSettings />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ModernPageNotFound />,
                    children: [
                        {
                            path: ROUTES.ACCOUNT_SETTINGS,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <EsSettings />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                            index: true,
                        },
                        {
                            path: ROUTES.ACCOUNT_BILLING,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountBilling />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_NOTIFICATIONS,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountNotifications />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_COMMUNICATIONS,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountCommunications />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_PREFERENCE,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountPreference />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_PREFERENCES,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountPreferences />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_SUBSCRIPTION,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountSubscription />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                        {
                            path: ROUTES.ACCOUNT_EXTERNAL_ACCOUNT,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ProtectedRoute>
                                        <AccountExternalBankAccounts />
                                    </ProtectedRoute>
                                </Suspense>
                            ),
                            errorElement: <ErrorBoundary />,
                        },
                    ],
                },
                {
                    path: ROUTES.MESSAGES,
                    element: (
                        <ProtectedRoute>
                            <Suspense fallback={<Spinner />}>
                                <Messages />
                            </Suspense>
                        </ProtectedRoute>
                    ),
                    children: [
                        {
                            path: ROUTES.MESSAGES_CONVERSATION,
                            element: (
                                <Suspense fallback={<Spinner />}>
                                    <ConversationView />
                                </Suspense>
                            ),
                        },
                    ],
                },
                {
                    path: ROUTES.MANAGE_EVENT,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute>
                                <ManageEvent />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },

                {
                    path: ROUTES.MANAGE_CONTEST,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute accessCheck accessType={['admin', 'host', 'super-admin']}>
                                <ManageContest />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
                {
                    path: ROUTES.MANAGE_SUBMISSION,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <ProtectedRoute>
                                <ManageSubmission />
                            </ProtectedRoute>
                        </Suspense>
                    ),
                    errorElement: <ErrorBoundary />,
                },
            ],
        },
        {
            path: ROUTES.ESNEWPASSWORD,
            element: (
                <Suspense fallback={<Loading />}>
                    <EsNewPassword />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.WORK_SHOP,
            element: (
                <Suspense fallback={<Loading />}>
                    <ProtectedRoute>
                        <WorkShop />
                    </ProtectedRoute>
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.PROJECT_DETAILS,
            element: (
                <Suspense fallback={<Loading />}>
                    <ProjectDetails />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.ESSIGNUP,
            element: (
                <Suspense fallback={<Loading />}>
                    <Signup />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.ESRESETPASSWORD,
            element: (
                <Suspense fallback={<Loading />}>
                    <EsResetPassword />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.VERIFY_EMAIL,
            element: (
                <Suspense fallback={<Loading />}>
                    <VerifyEmail />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.ACCEPT_JURY_INVITE,
            element: (
                <Suspense fallback={<Loading />}>
                    <JuryAcceptance />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.BUZZ_BRIDGE_LANDING,
            element: (
                <Suspense fallback={<Loading />}>
                    <BuzzBridge />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.LINKS,
            element: (
                <Suspense fallback={<Loading />}>
                    <Links />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.ESLOGIN,
            element: (
                <Suspense fallback={<Loading />}>
                    <EsLogin />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.FAQ,
            element: (
                <Suspense fallback={<Loading />}>
                    <FAQ />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.ADVERTISE,
            element: (
                <Suspense fallback={<Loading />}>
                    <Advertise />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.HELP_CENTER,
            element: (
                <Suspense fallback={<FooterPageShimmer />}>
                    <HelpCenter />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.TERMS_OF_USE,
            element: (
                <Suspense fallback={<FooterPageShimmer />}>
                    <TermsOfUse />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.SHOP,
            element: (
                <Suspense fallback={<Loading />}>
                    <Shop />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.PRIVACY_POLICY,
            element: (
                <Suspense fallback={<FooterPageShimmer />}>
                    <PrivacyPolicy />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.DELETE_ACCOUNT,
            element: (
                <Suspense fallback={<FooterPageShimmer />}>
                    <DeleteAccount />
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
        },
        {
            path: ROUTES.SOCIAL_AUTH_PAGE,
            element: <OAuthCallbackPage />,
        },
        {
            path: ROUTES.BRAND_ADHUB_CALLBACK,
            element: (
                <Suspense fallback={<Loading />}>
                    <BrandAdHubOAuthCallbackPage />
                </Suspense>
            ),
        },
        {
            path: ROUTES.CONTRACT_REVIEW,
            element: (
                <Suspense fallback={<Loading />}>
                    <ContractReviewPage />
                </Suspense>
            ),
        },
        {
            path: ROUTES.CONTEST_TOKEN_PAYSTACK_CALLBACK,
            element: (
                <Suspense fallback={<Loading />}>
                    <ContestTokenPaystackCallbackPage />
                </Suspense>
            ),
        },
        {
            path: ROUTES.BRAND,
            element: (
                <Suspense fallback={<Loading />}>
                    <ProtectedRoute>
                        <BrandDashboardLayout />
                    </ProtectedRoute>
                </Suspense>
            ),
            errorElement: <ErrorBoundary />,
            children: [
                {
                    index: true,
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandDashboardHome />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/new',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandNewCampaignPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/contest/:contestId/manage',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandContestManagePage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/:campaignId',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignDetailPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/:campaignId/accepted',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignAcceptedCreatorsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/:campaignId/report',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignReportPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/:campaignId/applications',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignApplicationsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'campaigns/:campaignId/participant/:participantId',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignParticipantPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'auditions/:auditionId',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandAuditionDetailPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'auditions/:auditionId/participant/:participantId',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandAuditionParticipantPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'find-talent',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandFindTalentPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'wallet',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandWalletPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'wallet/fund/callback',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandWalletFundCallbackPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'profile',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandProfilePage />
                        </Suspense>
                    ),
                },
                {
                    path: 'settings/subscription/callback',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandCampaignHostSubscriptionCallbackPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'settings',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandSubscriptionSettingsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageHome />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/team',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageTeamPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/contracts/new',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageContractCreatePage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/contracts/:contractId/sign',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageContractSignPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/contracts/:contractId',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageContractDetailPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/contracts',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageContractsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/calendar',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageCalendarPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/social',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageSocialPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/ai-engine',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageAiPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/inbox',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageInboxPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/settings',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageSettingsPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/my-contract',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageMyContractPage />
                        </Suspense>
                    ),
                },
                {
                    path: 'manage/ugc',
                    element: (
                        <Suspense fallback={<Loading />}>
                            <BrandManageUgcPage />
                        </Suspense>
                    ),
                },
            ],
        },
        {
            path: '*',
            element: (
                <Suspense fallback={<Loading />}>
                    <ModernPageNotFound />
                </Suspense>
            ),
        },
    ],
    {
        future: {
            v7_startTransition: true,
        },
    },
);
